import * as i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { enAccountsLocale } from '../../accounts/locale/accounts.en.ts';
import { enAuthLocale } from '../../accounts/locale/auth.en.ts';
import { enCommonLocale } from '../../common/locale/common.en.ts';
import { enErrorsLocale } from '../../common/locale/errors.en.ts';
import { enEnvironmentLocale } from '../../environment/locale/environment.en.ts';
import { enFeedbackLocale } from '../../feedback/locale/feedback.en.ts';
import { enLearnLocale } from '../../learn/locale/learn.en.ts';

import { getAppBuildUtil } from '../utils/app-build.util.ts';

import { enMainLocale } from './main.en';

export const localeResources = {
  en: {
    main: enMainLocale,
    common: enCommonLocale,
    errors: enErrorsLocale,
    environment: enEnvironmentLocale,
    auth: enAuthLocale,
    accounts: enAccountsLocale,
    learn: enLearnLocale,
    feedback: enFeedbackLocale,
  },
} as const;

void i18n.use(initReactI18next).init({
  debug: !getAppBuildUtil().isProductionBuild(),
  fallbackLng: 'en',
  defaultNS: 'main',
  interpolation: {
    escapeValue: false,
  },
  resources: localeResources,
});

// eslint-disable-next-line import/no-default-export
export default i18n;
